import React, { useState, useRef, useEffect } from "react";
import { makeStyles } from "tss-react/mui";
import { StyledTooltip } from "./Tooltip.js";
import { dashCharacter } from "../label/EmptyLabel.js";
import "../label/LabelHoc.js";
const useClasses = makeStyles()((theme) => ({
  multiLineAutoAdjustedWidthTooltipLabel: {
    lineHeight: theme.typography.h4.lineHeight,
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    "-webkit-box-orient": "vertical"
  },
  multiLineAutoAdjustedWidthTooltipLabelBreakByWords: {
    wordBreak: "break-word"
  },
  multiLineAutoAdjustedWidthTooltipLabelBreakByAllSymbols: {
    wordBreak: "break-all"
  },
  multiLineAutoAdjustedWidthTooltipLabelWhiteSpace: {
    whiteSpace: "normal"
  },
  multiLineAutoAdjustedWidthTooltipLabelNoWrap: {
    whiteSpace: "nowrap"
  },
  multiLineAutoAdjustedWidthTooltipOneLineLabel: {
    "-webkit-line-clamp": "1"
  },
  multiLineAutoAdjustedWidthTooltipTwoLineLabel: {
    "-webkit-line-clamp": "2"
  },
  multiLineAutoAdjustedWidthTooltipThreeLineLabel: {
    "-webkit-line-clamp": "3"
  },
  multiLineAutoAdjustedWidthTooltipFourLineLabel: {
    "-webkit-line-clamp": "4"
  },
  multiLineAutoAdjustedWidthTooltipFiveLineLabel: {
    "-webkit-line-clamp": "5"
  }
}));
const minLinesCount = 1;
const maxLinesCount = 5;
function MultiLineAutoAdjustedWidthTooltip({
  children,
  linesCount = minLinesCount,
  breakByWords = true
}) {
  const [isOverflowed, setIsOverflow] = useState(false);
  const textLinesCount = linesCount > minLinesCount ? maxLinesCount > linesCount ? linesCount : maxLinesCount : minLinesCount;
  const { classes, cx } = useClasses();
  const labelClassNameMapper = {
    1: classes.multiLineAutoAdjustedWidthTooltipOneLineLabel,
    2: classes.multiLineAutoAdjustedWidthTooltipTwoLineLabel,
    3: classes.multiLineAutoAdjustedWidthTooltipThreeLineLabel,
    4: classes.multiLineAutoAdjustedWidthTooltipFourLineLabel,
    5: classes.multiLineAutoAdjustedWidthTooltipFiveLineLabel
  };
  const textElementRef = useRef(null);
  const textElementOneLineWidth = useRef(null);
  useEffect(() => {
    if (textElementRef && textElementRef.current) {
      if (!textElementOneLineWidth.current) {
        textElementOneLineWidth.current = textElementRef.current.scrollWidth;
      }
      setIsOverflow(textElementOneLineWidth.current > textElementRef.current.clientWidth);
    }
  }, [textElementRef?.current?.clientWidth]);
  return children ? /* @__PURE__ */ React.createElement(
    StyledTooltip,
    {
      element: /* @__PURE__ */ React.createElement(
        "div",
        {
          ref: textElementRef,
          className: cx(
            isOverflowed ? classes.multiLineAutoAdjustedWidthTooltipLabelWhiteSpace : classes.multiLineAutoAdjustedWidthTooltipLabelNoWrap,
            breakByWords ? classes.multiLineAutoAdjustedWidthTooltipLabelBreakByWords : classes.multiLineAutoAdjustedWidthTooltipLabelBreakByAllSymbols,
            labelClassNameMapper[textLinesCount],
            classes.multiLineAutoAdjustedWidthTooltipLabel
          )
        },
        children
      ),
      title: /* @__PURE__ */ React.createElement("div", null, children),
      hideTooltip: !isOverflowed
    }
  ) : /* @__PURE__ */ React.createElement(React.Fragment, null, dashCharacter);
}
export {
  MultiLineAutoAdjustedWidthTooltip
};
//# sourceMappingURL=MultiLineAutoAdjustedWidthTooltip.js.map
